export default __webpack_public_path__ + "static/verification-icon-72a22670c0eeb7f28da153e2c5db1532.svg";